import React from "react";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";

export default function SubscriptionChoiceModal({ show, onClose, onChoose }) {
	return (
		<Modal show={show} size="lg" onHide={() => onClose(false)}>
			<Modal.Header>
				<h3>Monthly Package</h3>
			</Modal.Header>
			<Modal.Body>
				<p className="mb-0">Would you like this monthly package to renew automatically as a subscription?</p>
			</Modal.Body>
			<Modal.Footer className="d-flex flex-column flex-sm-row gap-2">
				<GradientButton
					title="Yes, make it a subscription"
					variant="greenYellow"
					onClick={() => onChoose(false)}
					className="flex-fill"
				/>
				<GradientButton
					title="No, once-off purchase"
					variant="yellowOrange"
					onClick={() => onChoose(true)}
					className="flex-fill"
				/>
			</Modal.Footer>
		</Modal>
	);
}
